import { render, staticRenderFns } from "./StudentExchangeOverviewWidget.vue?vue&type=template&id=4347e069&"
import script from "./StudentExchangeOverviewWidget.vue?vue&type=script&lang=ts&"
export * from "./StudentExchangeOverviewWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports